// extracted by mini-css-extract-plugin
export default {"container":"UserEventLayout_container__gLnZx"};